import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil, takeWhile, tap } from 'rxjs/operators';

@Component({
  selector: 'osn-shared-countdown-button',
  templateUrl: './countdown-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownButtonComponent implements OnInit, OnDestroy {
  @Input() public label: string;
  @Input() public timeoutInMillis: number;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public timeout = new EventEmitter();

  public progress = 0;
  public inXSeconds = 0;

  private readonly destroyed$ = new Subject<void>();

  private readonly reportProgressInterval = 50;
  private readonly percent = 100;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.inXSeconds = this.timeoutInMillis / 1000;
    interval(this.reportProgressInterval)
      .pipe(
        takeUntil(this.destroyed$),
        // eslint-disable-next-line rxjs/no-ignored-takewhile-value
        takeWhile(() => this.progress < this.percent),
        tap((times) => {
          this.progress = Math.round((((times + 1) * this.reportProgressInterval) / this.timeoutInMillis) * this.percent);
          this.inXSeconds = Math.floor((this.timeoutInMillis - times * this.reportProgressInterval) / 1000);

          if (this.progress >= this.percent) {
            this.timeout.emit();
          }

          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
